import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RemoveHtmlPipe } from './remove-html.pipe';

@NgModule({
  declarations: [RemoveHtmlPipe],
  imports: [CommonModule],
  exports: [RemoveHtmlPipe]
})
export class RemoveHtmlPipeModule {}
